// Validated categorical palette (see the project's dataviz skill,
// references/palette.md) — fixed hue order, not cycled/re-sorted by value,
// so a series keeps its color if the selection order doesn't change.
export const CATEGORICAL_LIGHT = ['#2a78d6', '#eb6834', '#1baf7a', '#eda100', '#e87ba4', '#008300', '#4a3aa7', '#e34948'];
export const CATEGORICAL_DARK = ['#3987e5', '#d95926', '#199e70', '#c98500', '#d55181', '#008300', '#9085e9', '#e66767'];

// For "no value" buckets (No region, Unknown...) — a neutral, never a
// categorical hue, so a gap never reads as one more real series.
export const NEUTRAL_LIGHT = '#9e9e9e';
export const NEUTRAL_DARK = '#757575';
